module.exports = __webpack_public_path__ + "static/media/plan-gigas-libres-plus-wom116.4b774e80.svg";